import React from 'react';
import { Card, CardContent } from '@/shared/ui/card';
import { AttachmentPhotoGallery } from '@/shared/components/AttachmentPhotoGallery';
import type { PhotoGroup } from '../types';

interface PhotoGalleryGridProps {
  groups: PhotoGroup[];
}

const formatGroupDate = (dateKey: string): string => {
  const parsed = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return dateKey;
  return parsed.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
};

export const PhotoGalleryGrid: React.FC<PhotoGalleryGridProps> = ({ groups }) => {
  if (groups.length === 0) {
    return (
      <Card>
        <CardContent className="py-10 text-center text-sm text-muted-foreground">
          No photos found for the current filters.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <section key={group.date} className="space-y-3">
          <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">
            {formatGroupDate(group.date)}
          </h2>
          <AttachmentPhotoGallery
            attachments={group.photos.map((photo) => ({
              id: photo.uuid,
              file: photo.original_file_name,
              file_url: photo.file_url || photo.gcs_url || null,
            }))}
            maxVisible={group.photos.length}
          />
        </section>
      ))}
    </div>
  );
};
